import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';

const TablaPresupuesto = ({ selectedProducts, setSelectedProducts, productos }) => {
    const [rowClick, setRowClick] = useState(true);
    const [globalFilter, setGlobalFilter] = useState('');

    useEffect(() =>{
        console.log(selectedProducts)
    },[selectedProducts])

    const onGlobalFilterChange = (e) => {
        setGlobalFilter(e.target.value);
    };

    return (
        <div>
            <span className='col-12'>Buscar</span>
            <div className="mb-4">
                <div className="p-inputgroup col-6">
                    <InputText className='col-12' placeholder="Buscar..." value={globalFilter} onChange={onGlobalFilterChange} />
                </div>
            </div>
            <DataTable 
                value={productos} 
                globalFilter={globalFilter}
                selectionMode={rowClick ? null : 'checkbox'} 
                selection={selectedProducts} 
                onSelectionChange={(e) => setSelectedProducts(e.value)} 
                dataKey="id" 
                tableStyle={{ minWidth: '50rem' }}
            >
                <Column selectionMode="multiple" headerClassName='header-table-style' headerStyle={{ width: '3rem' }}></Column>
                <Column field="codigo" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style' header="Codigo"></Column>
                <Column field="categoria_nombre" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style' header="Categoria"></Column>
                <Column field="nombre" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style' header="Nombre"></Column>
                <Column field="fabricante" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style' header="Fabricante"></Column>
                <Column field="precio_producto" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style' header="Precio Venta"></Column>
                <Column field="cantidad_disponible" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style' header="Cant. Disponible"></Column>

            </DataTable>
        </div>
    );
};

export default TablaPresupuesto;